var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/isarray/index.js
// module id = 266
// module chunks = 0